module.exports = __webpack_public_path__ + "img/mh.29b8c8bf.svg";